import React from 'react';
import { useTranslation } from 'react-i18next';

import type { NavbarData } from '../App';

import bg2 from '@/assets/bg2.png';
import logo2 from '@/assets/logo2.png';

export const CommunityJoin: React.FC<{ navbarData: NavbarData }> = ({ navbarData }) => {
  const { t } = useTranslation();

  const contactLinks = navbarData.contactUrl ?? [];

  return (
    <section className="section-page">
      <div className="max-w-7xl mx-auto">
        <div className="relative rounded-2xl overflow-hidden" style={{
          backgroundImage: `url(${bg2})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
          backgroundRepeat: 'no-repeat',
         }}>
          <div className="relative z-10 py-[clamp(3rem,10vw,6rem)] px-[clamp(1.25rem,5vw,3rem)] text-center">
            <div className="max-w-4xl mx-auto px-4 text-center">
              <div style={{ position: 'relative', zIndex: 1 }}>
                <div className="orbit-container">
                  <div className="orbit-ring orbit-ring-outer" />
                  <div className="orbit-ring orbit-ring-inner" />
                  <div className="orbit-dot orbit-dot-1" />
                  <div className="orbit-dot orbit-dot-2" />
                  <div className="orbit-dot orbit-dot-3" />
                  <div className="orbit-center">
                    <img src={logo2} alt="icon" style={{
                      inset: 30
                    }} />
                  </div>
                </div>
              </div>
            </div>
            <h2 className="mb-6 text-balance text-4xl font-normal leading-[1.05] text-white sm:mb-8 md:text-5xl">
              {t('join-title')}
            </h2>
            <p className="mx-auto mb-4 max-w-[min(100%,48rem)] text-pretty leading-snug text-white text-xl sm:text-2xl">
              {t('join-desc')}
            </p>
            <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
              {contactLinks.length > 0 ? (
                contactLinks.map((item, idx) => (
                  <a
                    key={idx}
                    href={item.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="interactive-scale rounded-full border-2 border-[#BCAAFF] px-[clamp(2rem,6vw,3.5rem)] py-3.5 text-xl font-normal text-white shadow-[inset_0_1px_21px_rgba(255,255,255,0.5)] transition-opacity hover:opacity-90 sm:py-4 sm:text-xl md:text-3xl"
                    style={{ background: 'radial-gradient(circle, #060026 0%, #5B22DB 95%, #5100FF 100%)' }}
                  >
                    {item.label}
                  </a>
                ))
              ) : (
                <button
                  type="button"
                  className="interactive-scale rounded-full border-2 border-[#BCAAFF] px-[clamp(2rem,6vw,3.5rem)] py-3.5 text-xl font-normal text-white shadow-[inset_0_1px_21px_rgba(255,255,255,0.5)] sm:py-4 sm:text-xl md:text-3xl"
                  style={{ background: 'radial-gradient(circle, #060026 0%, #5B22DB 95%, #5100FF 100%)' }}
                >
                  {t('join-button')}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
